import { useLDClient } from 'launchdarkly-react-client-sdk';

export const useDuplicateScanInterval = (): number => {
  const ldClient = useLDClient();
  return ldClient?.variation('pos.register.mobile-checkout-duplicate-scan-interval', 750) ?? 750;
};
